export default "__VITE_ASSET__UsmNKF8g__"